let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9RW1d")).then(() => parcelRequire('G6p7g'));